import {useMutation, useQueryClient} from 'react-query'
import {User} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: User) => {
    showNotification({
        title: 'User updated',
        icon: <Check/>,
        message: `User '${values.name}' has been updated!`,
    })
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the user. ${error}`,
        color: 'red'
    })
}

export default function useMutateUserData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload user data
            queryClient.invalidateQueries(['users']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
